require("component-responsive-frame/child");
require("./lazy-video");